import { useNavigate } from 'react-router-dom';

export const Home = () => {
    const navigate = useNavigate();
    return (
        <>
            <section class="relative h-[400px] flex items-center overflow-hidden">
                <div class="absolute inset-0 industrial-overlay"></div>
                <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div class="max-w-2xl">
                        <span
                            class="inline-block bg-primary text-white text-xs font-bold px-3 py-1 mb-4 uppercase tracking-widest"
                        >Est. 2007</span>
                        <h1 class="text-4xl md:text-6xl font-display font-bold text-white mb-4 uppercase leading-tight"
                        >
                            Premium Manufacturing <br /><span class="text-primary" >Quality Denim</span>
                        </h1>
                        <p class="text-slate-300 text-lg mb-8 font-light max-w-lg" >
                            By Om Clothing Co. We specialize in high-grade denim production, combining traditional craftsmanship
                            with modern industrial technology.
                        </p>
                        <div class="flex gap-4">
                            <button
                                class="bg-primary text-white px-8 py-3 font-bold uppercase tracking-wider hover:bg-orange-600 transition-all"
                            >Explore Collection</button>
                            <button
                                class="border border-white/30 text-white px-8 py-3 font-bold uppercase tracking-wider hover:bg-white/10 transition-all"
                            >Our Process</button>
                        </div>
                    </div>
                </div>
            </section>
            <section class="py-16 md:py-24 bg-slate-50 dark:bg-[#0a0a0b]">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
                        <div>
                            <h2 class="text-3xl md:text-5xl font-display font-bold uppercase tracking-tight text-slate-900 dark:text-white"
                            >
                                Women's <span class="text-primary" >Jeans</span>
                            </h2>
                            <div class="h-1 w-20 bg-primary mt-4"></div>
                        </div>
                        {/* <div class="flex flex-wrap gap-4">
                            <button
                                class="text-sm font-bold border-b-2 border-primary pb-1 text-slate-900 dark:text-white uppercase tracking-tighter"
                            >All Styles</button>
                            <button
                                class="text-sm font-bold text-slate-400 hover:text-primary pb-1 uppercase tracking-tighter transition-colors"
                            >Skinny</button>
                            <button
                                class="text-sm font-bold text-slate-400 hover:text-primary pb-1 uppercase tracking-tighter transition-colors"
                            >Straight</button>
                            <button
                                class="text-sm font-bold text-slate-400 hover:text-primary pb-1 uppercase tracking-tighter transition-colors"
                            >Wide Leg</button>
                            <button
                                class="text-sm font-bold text-slate-400 hover:text-primary pb-1 uppercase tracking-tighter transition-colors"
                            >Flare</button>
                        </div> */}
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div class="group cursor-pointer">
                            <div class="relative aspect-[3/4] overflow-hidden bg-slate-200 dark:bg-slate-800 rounded-sm">
                                <img alt="High-waist skinny blue jeans"
                                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuC0AliqnLF16yGutfSl0pnKukS06a3p69FNV5TBN6EsaxxwnmAFnvFZnPZeyyWBR79gBxnpgsDvZNHKMcMK85kQWw1BFXDGAPKboIlCF6CkKts_DBfYJbELzDYhuf5416v6Gw7VkciVrDrPAHSbCBU9bnjRv1GhvXvBqJ-9o84pWAfIEmsTdQrysUw26viJkTaNRCRrs_Xe8hp_wdEHnuTiARJIHQ6KjAcFYJQO8Z7DRrLTcKWykdTg8Onu0wtbQd0h3V9BkmIYjKcb"
                                />
                                <div class="absolute top-4 left-4">
                                    <span
                                        class="bg-primary text-white text-[10px] font-black px-2 py-1 uppercase tracking-widest"
                                    >Skinny</span>
                                </div>
                                <div
                                    class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <button onClick={() => navigate('/womens-jeans')} class="bg-white text-black px-6 py-2 font-bold uppercase text-xs tracking-widest"
                                    >Shop more</button>
                                </div>
                            </div>
                            <div class="mt-4 flex justify-between items-start">
                                <div>
                                    <h3 class="font-bold text-slate-900 dark:text-white uppercase tracking-tighter" >
                                        Midnight Blue Skinny</h3>
                                    <p class="text-slate-500 dark:text-slate-400 text-sm" >Premium Stretch Cotton</p>
                                </div>
                                <p class="font-display font-bold text-primary" >₹89.00</p>
                            </div>
                        </div>
                        <div class="group cursor-pointer">
                            <div class="relative aspect-[3/4] overflow-hidden bg-slate-200 dark:bg-slate-800 rounded-sm">
                                <img alt="Vintage straight leg jeans"
                                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuBNAGx4z6ng7GNkepkjRTqRCb8c1FhHDoCi2HFhrV8HdOay9EL-AfoknyHqogSV-HvxIog_vusRHxHuSs5DZGFKwBBBej7eeVGYdhmp9k0v2ybRA_XLEDxBcITj1as-ypFhu5yNgpiwT57XL_8kGYD8ansg0AHnyD7-8dcfycPNS0hWNecKPVvbs6c2lMh3syrzcc08GsNtH5qkMU00VdWSiQXYURaAIUAtoAd02y7o1AFnZMdBuiosqWXVzIeqQS4KiswySy1gDbBH"
                                />
                                <div class="absolute top-4 left-4">
                                    <span
                                        class="bg-primary text-white text-[10px] font-black px-2 py-1 uppercase tracking-widest"
                                    >Straight</span>
                                </div>
                                <div
                                    class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <button onClick={() => navigate('/womens-jeans')} class="bg-white text-black px-6 py-2 font-bold uppercase text-xs tracking-widest"
                                    >Shop more</button>
                                </div>
                            </div>
                            <div class="mt-4 flex justify-between items-start">
                                <div>
                                    <h3 class="font-bold text-slate-900 dark:text-white uppercase tracking-tighter" >
                                        Vintage Straight</h3>
                                    <p class="text-slate-500 dark:text-slate-400 text-sm" >Classic Rigid Denim</p>
                                </div>
                                <p class="font-display font-bold text-primary" >₹95.00</p>
                            </div>
                        </div>
                        <div class="group cursor-pointer">
                            <div class="relative aspect-[3/4] overflow-hidden bg-slate-200 dark:bg-slate-800 rounded-sm">
                                <img alt="Wide leg charcoal jeans"
                                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuCgQ1net4CsYPGR673kOZKlNfumMd7qRaZZo6wTqvSy4_DwQPDoAZGeVW9-jrW1WdpvZ8yTrj2c4-5lxrwhtG2kdbFrXcgOcS3k7FOkUHvvVKfJMswhsaCTqD83kuEFpACMHZfJDtNpbl7qRKZrjRAGLmoQQgMR2A5_2weZv6TNM7DRBeL1a5nFjii1Elm5J_NrXcTjhWugY8879mqIm72RmYKg0DfHdHf2xPbt9o36CkrUbNqUqBD3jPBcBMrdRnWqicdkmCss1dkM"
                                />
                                <div class="absolute top-4 left-4">
                                    <span
                                        class="bg-primary text-white text-[10px] font-black px-2 py-1 uppercase tracking-widest"
                                    >Wide Leg</span>
                                </div>
                                <div
                                    class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <button onClick={() => navigate('/womens-jeans')} class="bg-white text-black px-6 py-2 font-bold uppercase text-xs tracking-widest"
                                    >Shop more</button>
                                </div>
                            </div>
                            <div class="mt-4 flex justify-between items-start">
                                <div>
                                    <h3 class="font-bold text-slate-900 dark:text-white uppercase tracking-tighter" >
                                        Loft Wide Leg</h3>
                                    <p class="text-slate-500 dark:text-slate-400 text-sm" >Industrial Charcoal Wash</p>
                                </div>
                                <p class="font-display font-bold text-primary" >₹110.00</p>
                            </div>
                        </div>
                        <div class="group cursor-pointer">
                            <div class="relative aspect-[3/4] overflow-hidden bg-slate-200 dark:bg-slate-800 rounded-sm">
                                <img alt="Distressed boyfriend jeans"
                                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuBId1DFtPmXbJxdgZOyTqMT322a6FPUA6K6xDj_wCuW5OBFSs5Jv0d5oY4de-o1pHoVV8oOngZJc7ecs7LKSIpGVNPfqxYd8arT9RDW4DuaOSWQhAoM4yLaBnApusGyv3ywQoetE9bvgYVuAGQPvHWzHTkVK8JcwqATCIinYItsxilkR0PbHD_ZfTkYMeVpSFrkGBZ8khUqAdNdBzzXGdrUxXY1fMOgWXPRrUYj0tdoqowY6C_L6DzE-5FTHgPx3r5hrve6IxKnUOEg"
                                />
                                <div class="absolute top-4 left-4">
                                    <span
                                        class="bg-primary text-white text-[10px] font-black px-2 py-1 uppercase tracking-widest"
                                    >Distressed</span>
                                </div>
                                <div
                                    class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <button onClick={() => navigate('/womens-jeans')} class="bg-white text-black px-6 py-2 font-bold uppercase text-xs tracking-widest"
                                    >Shop more</button>
                                </div>
                            </div>
                            <div class="mt-4 flex justify-between items-start">
                                <div>
                                    <h3 class="font-bold text-slate-900 dark:text-white uppercase tracking-tighter" >
                                        Urban Distressed</h3>
                                    <p class="text-slate-500 dark:text-slate-400 text-sm" >Streetwear Ready</p>
                                </div>
                                <p class="font-display font-bold text-primary">₹105.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-16 text-center">
                        <button
                            class="border-2 border-slate-900 dark:border-white text-slate-900 dark:text-white px-10 py-4 font-bold uppercase tracking-widest hover:bg-slate-900 hover:text-white dark:hover:bg-white dark:hover:text-black transition-all">
                            Load More Styles
                        </button>
                    </div>
                </div>
            </section>
            <section class="py-20 bg-white dark:bg-background-dark border-y border-slate-200 dark:border-slate-800">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
                        <div class="flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                                <span class="material-icons text-primary text-3xl" >verified</span>
                            </div>
                            <h4 class="font-display font-bold text-xl uppercase mb-2" >Premium Quality</h4>
                            <p class="text-slate-500 dark:text-slate-400 text-sm" >Every pair of jeans is crafted with
                                high-density denim and premium hardware for lasting durability.</p>
                        </div>
                        <div class="flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                                <span class="material-icons text-primary text-3xl" >factory</span>
                            </div>
                            <h4 class="font-display font-bold text-xl uppercase mb-2" >In-House Production</h4>
                            <p class="text-slate-500 dark:text-slate-400 text-sm" >Full control over the manufacturing
                                cycle at our Asmeeta Textile Park facility in Maharashtra.</p>
                        </div>
                        <div class="flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                                <span class="material-icons text-primary text-3xl" >history_edu</span>
                            </div>
                            <h4 class="font-display font-bold text-xl uppercase mb-2" >Since 2007</h4>
                            <p class="text-slate-500 dark:text-slate-400 text-sm" >Over 15 years of excellence in
                                supplying premium quality denim to retailers and wholesalers.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}